import { render, staticRenderFns } from "./MaterialLifecycleSelect.vue?vue&type=template&id=0fce3013&scoped=true"
import script from "./MaterialLifecycleSelect.vue?vue&type=script&lang=js"
export * from "./MaterialLifecycleSelect.vue?vue&type=script&lang=js"
import style0 from "./MaterialLifecycleSelect.vue?vue&type=style&index=0&id=0fce3013&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fce3013",
  null
  
)

export default component.exports